<div class="c-appHeaderContainer">
  <div class="c-appHeader">
    <!-- Header Info Section (Logo & Role Switcher) -->
    <div class="c-appHeader__info">
      <!-- Side Menu Toggle Button (Mobile) -->
      <span
        class="nav-mobile-menu-btn side-menu-btn open"
        (click)="toggleSideMenu()"
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </span>

      <!-- Brand Logo with Responsive Image -->
      <a
        [href]="storeUrl"
        target="_blank"
        class="navbar-brand c-appHeader__brand"
      >
        <picture>
          <source
            srcset="assets/images/brand--mini.png"
            media="(max-width: 1200px)"
          />
          <img
            src="assets/images/brand-lg.png"
            class="c-appHeader__brandImage"
            alt="Storeverse"
          />
        </picture>
      </a>

      <!-- Role Switcher Component -->
      <div class="dropdown c-appHeader__roleSwitcher">
        <sv-role-switcher></sv-role-switcher>
      </div>
    </div>

    <!-- Navigation Section -->
    <div class="c-appHeader__navigation">
      <app-main-navigation></app-main-navigation>
    </div>

    <!-- Tools Section (Lang Switcher & User Profile) -->
    <div class="c-appHeader__tools">
      <!-- Language Switcher -->
      <div class="c-appHeader__toolsItem dropdown-right">
        <sv-lang-switcher></sv-lang-switcher>
      </div>

      <!-- User Profile Dropdown -->
      <div class="c-appHeader__toolsItem dropdown-right">
        <!-- Mobile Toggle Button -->
        <span
          class="nav-mobile-menu-btn account-btn hidden"
          (click)="toggleNavbar({ dropdownVisible: true })"
        >
          <i class="fas fa-user"></i>
        </span>

        <!-- Desktop User Profile Button -->
        <div ngbDropdown class="d-inline-block" placement="bottom-end">
          <button
            class="btn btn-clean btn--iconMuted"
            id="navbarDropdown2"
            ngbDropdownToggle
            [svHideCaret]="true"
          >
            <span class="c-btn__title">{{ (authUser$ | async)?.name }}</span>
            <sv-icon iconClass="iconFont-person"></sv-icon>
          </button>
          <ul
            class="dropdown-menu"
            ngbDropdownMenu
            aria-labelledby="navbarDropdown2"
          >
            <li>
              <a
                class="dropdown-item"
                routerLink="/dashboard"
                (click)="closeNavbar()"
                ngbDropdownItem
              >
                {{ "GLOBAL.G071" | localeTrans: { trace: true } }}
              </a>
            </li>
            <li>
              <div class="dropdown-divider"></div>
            </li>
            <li>
              <a
                class="dropdown-item"
                routerLink="/dashboard/profile"
                (click)="closeNavbar()"
                ngbDropdownItem
              >
                {{ "GLOBAL.G072" | localeTrans: { trace: true } }}
              </a>
            </li>
            <li>
              <div class="dropdown-divider"></div>
            </li>
            <li>
              <a
                class="dropdown-item cursor-pointer"
                (click)="handleLogout()"
                ngbDropdownItem
                href="javascript:void(0)"
              >
                {{ "GLOBAL.G073" | localeTrans: { trace: true } }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
